import { MFieldName } from '../types/MandatoryFields';

export const DH = {
  Root: `wcn-payment-widget`,
  MainLoader: `cc-spinner-main`,
  Loader: `cc-spinner`,
  ContentWrapper: `pw-content-wrapper`,

  PayButton: {
    Button: `cashier-payments-method-pay-button`,
    Loader: `pw-pay-button-loader`,
  },

  LazyLoadErrorMessage: `pw-lazy-load-error`,
  InitErrorMessage: `pw-init-error`,
  PaymentErrorMessage: `pw-payment-error`,

  CollapsedPayment: {
    Container: `wcn-collapsed-payment`,
    Icon: `wcn-collapsed-payment-icon`,
  },

  ModalLayout: {
    Modal: `pw-modal`,
    Header: `wcn-modal-layout-header`,
    Title: `pw-modal-layout-title`,
    CloseButton: `pw-modal-layout-close-btn`,
  },

  FramedModal: {
    Container: `pw-modal-container`,
    Loader: `pw-modal-loader`,
    InnerFrame: `pw-modal-pp-page`,
    Custom: {
      FrameContainer: `pw-modal-frame-container`,
      Frame: `pw-modal-iframe`,
    },
  },

  Boleto: {
    Overlay: `boleto-modal-overlay`,
    Container: `boleto-modal-container`,
    Title: `boleto-title`,
    Number: `boleto-barcode-number`,
    PrintButton: `boleto-print-button`,
    CloseButton: `boleto-close-button`,
    BarCode: `boleto-barcode`,
    BankSelector: {
      Container: `boleto-bank-selector-container`,
      Description: `boleto-bank-selector-description`,
      DropdownContainer: `boleto-bank-selector-dropdown-container`,
      LoginButton: `boleto-bank-selector-login-btn`,
    },
  },

  InstantPayment: {
    Container: `instant-payment-container`,
    Logo: `instant-payment-logo`,
    Total: `instant-payment-total`,
    Description: `instant-payment-description`,
    QRCode: `instant-payment-qrcode`,
    ExpirationTimer: `instant-payment-expiration-timer`,
    CopyButton: `instant-payment-copy-btn`,
    CancelButton: `instant-payment-cancel-btn`,
  },

  CopyButton: {
    Root: `copy-button-root`,
    TextArea: `copy-btn-textarea`,
    Button: `copy-btn-button`,
  },

  Dropdown: {
    Container: `cashier-payments-method-dropdown-container`,
    Select: `cashier-payments-method-dropdown-input`,
    InputWithLabel: `cashier-payments-method-dropdown-input-with-label`,
    Option: (id: string) => `cashier-payments-method-dropdown-option-${id}`,
    Icon: `cashier-payments-method-dropdown-input-icon`,
    Arrow: `cashier-payments-method-dropdown-input-arrow`,
  },

  NoPaymentsMethods: {
    Container: `cashier-no-payment-methods-container`,
    Title: `cashier-no-payment-methods-title`,
    Content: `cashier-no-payment-methods-content`,
    RefreshButton: `cashier-no-payment-methods-refresh-btn`,
  },

  TermsAndSubmit: {
    Container: `pw-terms-and-submit-container`,
    Checkbox: `wcn-wallet-payment-terms-input`,
    Error: `wcn-wallet-payment-terms-error`,
  },

  MethodsList: {
    Container: `wcn-payment-method-list`,
    ScreenWrapper: `pw-pm-list-screen-wrapper`,
    Item: {
      Wrapper: (methodName: string) => `payment-method-item-${methodName}`,
      Container: `wcn-payment-method-item`,
      Title: `wcn-payment-method-item-title`,
      Radio: (methodName: string) =>
        `wcn-payment-method-item-input-${methodName}`,
      Icon: `pw-pm-icon`,
      SupportedCardNetworks: `pw-pm-supported-networks`,
    },
  },

  SavedCard: {
    List: `wcn-saved-cc-list`,
    Item: {
      Wrapper: (cardId: string) => `payment-saved-cc-item-${cardId}`,
      Container: `wcn-saved-cc-item`,
      Radio: (cardId: string) => `wcn-saved-cc-item-input-${cardId}`,
      ExpiredMessage: `wcn-saved-cc-expired`,
      LastDigits: `wcn-saved-cc-item-last-digits`,
      ExpireDate: `wcn-saved-cc-item-expire-date`,
    },
  },

  PaymentMethod: {
    Container: `cashier-payments-method`,
    LayoutDefault: `wcn-cashier-payments-method-layout`,
    CreditCard: {
      Container: `cashier-payments-method-creditCard`,
      SaveCard: {
        Container: `cashier-payments-method-saveCard`,
        Checkbox: `cashier-payments-method-saveCard-checkbox`,
        Tooltip: `cashier-payments-method-saveCard-tooltip`,
      },
    },
    InPerson: `cashier-payments-method-inPerson`,
    Offline: `cashier-payments-method-offline`,
    Wallet: {
      Container: (walletName: string) =>
        `cashier-payments-method-wallet-${walletName}`,
      Title: `wallet-title`,
      Icon: `wcn-payment-method-logo`,
      Description: `wallet-description`,
      MoreInfoModal: `pw-wallet-more-info-modal`,
      StaticInstallment: {
        Root: `pw-wallet-static-installments`,
        Description: `pw-wallet-static-installments-description`,
        MoreInfo: `pw-wallet-static-installments-more-info`,
        MoreInfoButton: `pw-wallet-static-installments-more-info-button`,
      },
    },
  },

  PaymentDetails: {
    Container: `cashier-payments-method-payment-details`,
    FieldWrapper: (mfName: MFieldName) => `pw-pd-field-wrapper-${mfName}`,
    FieldContainer: `cashier-payments-method-field`,

    TextField: {
      Container: `cashier-payments-method-field-textField`,
      Label: `pw-field-label`,
      Input: (mfName: MFieldName) =>
        `cashier-payments-method-field-textField-${mfName}`,
      Asterisk: `pw-field-required`,
      ErrorMessage: (mfName: MFieldName) => `text-field-error-label-${mfName}`,
    },

    DropdownField: {
      Error: `cashier-payments-method-dropdownField-error`,
      Label: `cashier-payments-method-dropdownField-label`,
      Dropdown: `cashier-payments-method-dropdownField-dropdown`,
      Loader: `cashier-payments-method-DropdownField-loader`,
      Asterisk: `cashier-payments-method-DropdownField-asterisk`,
    },

    CountryDropdown: `cashier-payments-method-countryDropdown-dropdown`,
    StateDropdown: `cashier-payments-method-stateAutoDropdown-dropdown`,

    BankDropdown: {
      Container: `cashier-payments-method-bankSelector`,
      Label: `cashier-payments-method-BankSelector-label`,
      Error: `cashier-payments-method-bankSelector-error`,
    },
  },
};
